
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/t",
      function () {
        return require("private-next-pages/t.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/t"])
      });
    }
  